import { useDebouncedApiValidation } from "../../hooks/useDebouncedApiValidation";
import { object, string } from "yup";
import { Field } from "./Field";
import { get } from "lodash";

export const PropertyField = ({ field, control }) => {
    const { property, params = {} } = field;

    const validationUrl = property?.config?.validation?.url;
    const validationParams = property?.config?.validation?.parameters || [];

    const validate = useDebouncedApiValidation({
        url: validationUrl,
        ...validationParams.reduce((acc, parameter) => ({
            ...acc,
            [parameter.name]: get(params, parameter.path, "")
        }), {})
    });

    if (validationUrl) {
        field.validation = object().shape({ value: string().required("Required").test(validate) }).nullable().required("Required");
        field.checkingMessage = "Checking...";
        field.validMessage = "Active";
    }

    return <Field field={field} control={control}/>;
};
